import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function Knob({ isDownloadMode, downloadAs }) {
  const width = isDownloadMode ? 295 : getAccuratePixels(295);

  const border = useMemo(() => {
    if (downloadAs == "cutout-png") {
      return "1px solid black";
    }

    if (downloadAs == "icon-png") {
      return null;
    }

    return "2px solid #6495ED";
  }, [downloadAs]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          width: width,
          height: width,
          border: border,
          borderRadius: "50%",
        }}
      ></div>
    </div>
  );
}

export default Knob;
